import { useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { fileUrl, language, useFETCH } from "../../Tools/APIs";
import { Col, Row } from "../../Tools/Grid-system";
import Pagination from "../../Tools/Pagination";
import { Promotion } from "../../components";
import { content } from "../../Context/translate";
import Loading from "../../Tools/Loading";

function Blog() {
  const { data, isLoading } = useFETCH("v1/blog/sections?paginate=0");
  const [idBlog, setIdBlog] = useState(1);
  const [searchKey, setSearchKey] = useState('');
  const [debouncedSearchKey, setDebouncedSearchKey] = useState('');

  // Debounce effect for search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchKey(searchKey);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchKey]);

  useEffect(() => {
    setIdBlog(data?.data?.data[0]?.id);
  }, [data?.data?.data]);

  if (isLoading) return <Loading />;

  return (
    <Col md={11} className="mx-auto ">
      <>
        <h1 className="font-bold text-3xl  text-Secondary mt-12 mb-12">
          {content.Categories}
        </h1>
        <div className="flex gap-3 pb-5 overflow-x-auto ">
          {data?.data?.data?.map((e) => (
            <div
              onClick={() => {
                setIdBlog(e.id);
              }}
              className={`${
                idBlog === e.id
                  ? "bg-Main text-white shadow-sm shadow-Main"
                  : "text-black bg-gray-200 border "
              } min-w-[150px] flex justify-center items-center hover:bg-Main hover:text-white transition-all hover:shadow-sm  hover:shadow-Main  rounded-md px-5 py-3 font-semibold max-sm:text-sm max-sm:py-2 max-sm:px-3 mx-auto cursor-pointer `}
            >
              {e.name}
            </div>
          ))}
        </div>
        <h2 className="font-bold  text-3xl text-Secondary mb-12 mt-12">
          {content.Blogs}
        </h2>
        <div className="w-full max-w-md mx-auto mb-8">
          <input
            type="text"
            placeholder="Search blogs..."
            value={searchKey}
            className="w-full px-4 py-2 rounded-md border border-Main focus:outline-none focus:ring-2 focus:ring-Main focus:border-transparent"
            onChange={(e) => {
              setSearchKey(e.target.value);
            }}
          />
        </div>
      </>
      <Posts sectionId={idBlog} searchKey={debouncedSearchKey} setSearchKey={setSearchKey} />
      <Promotion />
    </Col>
  );
}
export default Blog;

const Posts = ({ sectionId, searchKey = '' , setSearchKey }) => {
  // const  search  = useLocation();
  const location = useLocation();
  const searchSlug = location.state?.searchSlug;

  // const { data, isLoading } = useFetch(
  //   sectionId && `v1/blog/sections/${sectionId}/posts${search}`
  // );

  useLayoutEffect(() => {
    // console.log("searchSlug", searchSlug);
    setSearchKey(searchSlug);
  }, [searchSlug]);

  const { data, isLoading } = useFETCH(
    sectionId && `v1/blog/posts?section_id=${sectionId}&lang=${language}${searchKey ? '&tags=' + searchKey : '' }`
  );

  function replaceSpacesWithUnderscore(str) {
  return str.replace(/ /g, "_");
}

  return (
    <Pagination
      pageCount={Math.ceil(
        data?.data?.total / data?.data?.per_page
      )}>
      <Row justify={"between"}>
        {isLoading ? (
          <>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
          </>
        ) : (
          data?.data?.data?.map((e) => (
            <Col md={4} xs={6} sm={11} className="flex justify-between mx-4 ">
              <div className=" rounded-2xl shadow-md shadow-Main w-full overflow-hidden hover:scale-110 transition-all mt-8">
                <div className="h-[220px] w-full">
                  <img
                    src={fileUrl + e.image}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="font-semibold md:text-md text-black my-3 left-7  px-2 text-center">
                  {e.title.length > 50
                    ? e.title.substring(0, 60) + "..."
                    : e.title}
                </p>
                <p className="max-md:text-sm p-2">
                  <div className="text-end">
                    <Link to={`/blog/${replaceSpacesWithUnderscore(e.title)}`} state={{postId: e.id}}>
                      <span className="text-Secondary text-sm font-bold underline mx-2">
                        {content.ReadMore}
                      </span>
                    </Link>
                  </div>
                </p>
              </div>
            </Col>
          ))
        )}
      </Row>
    </Pagination>
  );
};
